import classNames from "classnames";
import React, { ReactNode, useEffect } from "react";
import { SitePage } from "../../types/SitePage";
import TopNav from "../TopNav/TopNav";
import "./PageLayout.scss";

interface PageLayoutProps {
  children: ReactNode;
  page: SitePage;
  title?: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, page, title }) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} - PoolTonight`;
    }
  }, [title]);

  const pageLayoutClass = classNames("page-layout", {
    [page]: true,
    "textured-background": page !== SitePage.Map,
  });

  return (
    <div className={pageLayoutClass}>
      <TopNav page={page} />
      <main className="page-content">{children}</main>
    </div>
  );
};

export default PageLayout;
